
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzPageList from "@/models/MiezzPageList";
import DtoPageListSearchOrderPoolTrunk from "@/models.machine/DtoPageListSearchOrderPoolTrunk";
import DtoListItemOrderPoolTrunk from "@/models.machine/DtoListItemOrderPoolTrunk";
import CurrentLogier from "@/apis/CurrentLogier";
import { MiezzMenuTab } from "@/components/MiezzMenuTab.vue";
import { EnumOrderServiceType } from "@/models.machine/EnumOrderServiceType";
import TrunkPageList from "../../Pool/Trunk/TrunkPageList.vue";
@Options({
  components: {
    TrunkPageList,
  },
})
export default class DeparturePortTrunkPageList extends Vue {
  menuTab = new MiezzMenuTab();
  list = new MiezzPageList<
    DtoPageListSearchOrderPoolTrunk,
    DtoListItemOrderPoolTrunk,
    string
  >("OrderManagement_Order_Summary_DeparturePortTrunk");
  powers: string[] = [];
  serviceType = EnumOrderServiceType.DeparturePort;

  created(): void {
    CurrentLogier.GetPowerCodes().then((r) => {
      this.powers = r ?? [];
      if (
        this.powers.contains(
          "OrderManagement_Order_Summary_DeparturePortTrunk_Delete"
        )
      ) {
        this.list.RowButtons = [
          {
            Code: "delete",
            Title: "删除",
            Icon: "delete",
            Type: "default",
            Size: "small",
            Message: "是否确认删除",
            PowerCode: "OrderManagement_Order_Summary_DeparturePortTrunk_Delete",
          },
        ];
      }
    });

    this.menuTab.Back = true;
    this.menuTab.Url = `/order/departure-port-trunk/${this.$route.params.id}`;
    this.menuTab.Menus = [
      {
        Label: "装货港-干线物流",
        Url: `/order/departure-port-trunk/${this.$route.params.id}`,
        Power: "OrderManagement_Order_Summary_DeparturePortTrunk",
      },
    ];
  }
}
